module.exports = __webpack_public_path__ + "static/media/Gotham-BookItalic.07e6e69f.woff";